export function checkHasVhBug() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const lowerCaseUserAgent = userAgent.toLowerCase()
  if (!userAgent) return false

  const isAndroid = /android/.test(lowerCaseUserAgent)
  const isIos = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

  let regexp
  if (isAndroid) {
    regexp = /fban|fbav|instagram|snapchat|nrk|firefox|opera|klar\//
  } else if (isIos) {
    regexp = /fban|fbav|instagram|snapchat|nrk|firefox|opera|chrome|fxios|crios/
  }

  return regexp && regexp.test(lowerCaseUserAgent)
}

export const throttle = (func, limit) => {
  let lastFunc
  let lastRan
  return function() {
    const context = this
    const args = arguments
    if (!lastRan) {
      func.apply(context, args)
      lastRan = Date.now()
    } else {
      clearTimeout(lastFunc)
      lastFunc = setTimeout(function() {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args)
          lastRan = Date.now()
        }
      }, limit - (Date.now() - lastRan))
    }
  }
}
